import { red } from '@ant-design/colors';
import { InfoCircleFilled } from '@ant-design/icons';
import type { MenuProps, ThemeConfig } from 'antd';

export type MenuItem = Required<MenuProps>['items'][number];

export const Color = {
  primary: '#7B67EF',
  subPrimary: '#a99df5',
  primaryBlack: '#160a0a',
  darkGray: '#AFAEAE',
  middleGray: '#D9D9D9',
  lightGray: '#FAFAFA',
  darkRed: red[4],
  alert: '#FF7875'
};

export const BorderRadius = 8;
export const contnetFontSize = 16;

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#7b67ef',
    borderRadius: BorderRadius,
    // trackMinWidthSM: 28, // 小号 switch 宽度
    fontFamily: 'Helvetica Neue, sans-serif'
  },
  components: {
    Button: {
      colorPrimary: Color.primaryBlack,
      colorPrimaryHover: Color.subPrimary
    },
    Switch: {
      colorPrimary: Color.primaryBlack,
      colorPrimaryHover: Color.subPrimary
    },
    Checkbox: {
      colorPrimary: Color.primaryBlack,
      colorPrimaryHover: Color.subPrimary
    }
  },
  hashed: false
};

export function uploadErrorItem(originNode: React.ReactElement, result: string): React.ReactNode {
  return (
    <div>
      {originNode}
      <div style={{ color: Color.darkRed, display: 'flex', marginTop: 4 }}>
        <InfoCircleFilled />
        <div style={{ marginLeft: 8 }}>{result}</div>
      </div>
    </div>
  );
}

export function getItem({
  label,
  key,
  icon,
  children,
  onClick
}: {
  label: React.ReactNode;
  key: React.Key;
  icon?: React.ReactNode;
  children?: MenuItem[];
  onClick?: () => void;
}): MenuItem {
  const result: MenuItem = {
    key,
    icon,
    children,
    label,
    onTitleClick: onClick
  };

  return result;
}
/**
 * 计算元素在父元素中的位置
 * @param targetElement 需要计算的元素
 * @param parentElement 父元素
 */
export const calcRectInParentElement = (
  targetElement: HTMLElement,
  parentElement: HTMLElement
): DOMRect => {
  const rect = targetElement.getBoundingClientRect();
  // Get the bounding client rect of the parent element.
  const parentRect = parentElement.getBoundingClientRect();
  // Get the scroll positions
  const parentScrollLeft = parentElement.scrollLeft;
  const parentScrollTop = parentElement.scrollTop;

  const rectRelativeToParent = {
    ...rect,
    top: rect.top - parentRect.top + parentScrollTop,
    bottom: rect.bottom - parentRect.top,
    left: rect.left - parentRect.left + parentScrollLeft,
    right: rect.right - parentRect.left,
    x: rect.x - parentRect.left,
    y: rect.y - parentRect.top,
    width: rect.width,
    height: rect.height
  };

  return rectRelativeToParent;
};
